import { SCREEN_SIZES } from "utils/constants";
import { useMediaQuery } from "react-responsive";
import { useEffect } from "react";

// This hook is used to scroll to the active page on mobile devices
const useAutomaticScroll = (className) => {
	const isDesktop = useMediaQuery({ minWidth: SCREEN_SIZES.lg });

	useEffect(() => {
		const activePage = document.querySelector(className);
		if (!activePage || isDesktop) return;
	
		activePage.scrollIntoView({ block: "nearest", inline: "center", behavior: "smooth" });
	}, []);
};

export default useAutomaticScroll;